import React, {PureComponent} from 'react';
import {
    LineChart, Line, XAxis, Area,
    YAxis, CartesianGrid, Tooltip,
    Legend, ResponsiveContainer, AreaChart,
    Label
} from 'recharts';


export default class PPAChart extends PureComponent {
    static demoUrl = 'https://codesandbox.io/s/simple-line-chart-kec3v';

    getLines() {
        let lines = []
        this.props.config.lines.forEach(d => {
            lines.push(
                <Area type="monotone" dataKey={d} stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
            )
        })
    }

    getData = () => {
        //handle no data case, only show first value of year in chart
        return (this.props.data || []).reduce((r,d) => {
            if (!r.map(j => j.year).includes(d.year)) {
                r.push({...d}) //, cost_per_kwh: Math.round(r.cost_per_kwh * 100) / 100})
            }
            return r;
        }, [])
    }

    getTickValues = () => {
        let data = this.props.data || [];
        let min = Math.min(...data.map(d => d.cost_per_kwh))
        let max = Math.max(...data.map(d => d.cost_per_kwh))
        let tickVals = [];

        // start on even number 4 cents below price
        let first_tick = Math.floor(min - .04)
        if (first_tick % .02 !== 0) { //odd
            first_tick += .01
        }
        //no negative pricing
        if (first_tick < 0) {
            first_tick = 0
        }

        tickVals.push(first_tick)

        let tickVal = first_tick;
        while (tickVal < max + .04) {
            tickVal += .02;
            tickVals.push(tickVal)
        }

        return tickVals;

    }
    tickFormatter = (val) => {
        const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        return formatter.format(Math.round(val * 100) / 100)
    }

    render() {
        return (
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart width={730} height={250} data={this.getData()}
                           margin={{ top: 10, right: 30, left: 20, bottom: 10 }}
                           padding={{bottom:20}}
                >

                    <defs>
                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
                        </linearGradient>
                        <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
                        </linearGradient>
                    </defs>
                    <XAxis dataKey="year">
                        <Label position={'insideBottom'} offset={-10}>
                            Year
                        </Label>
                    </XAxis>
                    <YAxis
                        domain={[dataMin => dataMin - (dataMin * .3), dataMax => dataMax + (dataMax * .15)]}
                        tickFormatter={this.tickFormatter}
                        // ticks={this.getTickValues()}
                        interval={"preserveStartEnd"}
                        // allowDecimals={false}
                    >
                        <Label angle={270} position='left' style={{ textAnchor: 'middle' }}>
                            Cost/kWh ($)
                        </Label>
                    </YAxis>
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    <Area type="monotone" dataKey="cost_per_kwh" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
                </AreaChart>
            </ResponsiveContainer>
        );
    }
}


const data = [
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 1,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 2,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 3,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 4,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 5,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 6,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 7,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 8,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 9,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 10,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 11,
        "year": 1
    },
    {
        "payment": 4737.5,
        "fees": 0,
        "payment_w_fees": 4737.5,
        "cost_per_kwh": 0.28424999999999995,
        "number": 12,
        "year": 1
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 13,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 14,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 15,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 16,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 17,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 18,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 19,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 20,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 21,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 22,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 23,
        "year": 2
    },
    {
        "payment": 4760.95,
        "fees": 0,
        "payment_w_fees": 4760.95,
        "cost_per_kwh": 0.2870925,
        "number": 24,
        "year": 2
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 25,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 26,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 27,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 28,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 29,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 30,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 31,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 32,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 33,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 34,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 35,
        "year": 3
    },
    {
        "payment": 4784.52,
        "fees": 0,
        "payment_w_fees": 4784.52,
        "cost_per_kwh": 0.289963425,
        "number": 36,
        "year": 3
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 37,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 38,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 39,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 40,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 41,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 42,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 43,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 44,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 45,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 46,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 47,
        "year": 4
    },
    {
        "payment": 4808.2,
        "fees": 0,
        "payment_w_fees": 4808.2,
        "cost_per_kwh": 0.29286305925,
        "number": 48,
        "year": 4
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 49,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 50,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 51,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 52,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 53,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 54,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 55,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 56,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 57,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 58,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 59,
        "year": 5
    },
    {
        "payment": 4832,
        "fees": 0,
        "payment_w_fees": 4832,
        "cost_per_kwh": 0.2957916898425,
        "number": 60,
        "year": 5
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 61,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 62,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 63,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 64,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 65,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 66,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 67,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 68,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 69,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 70,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 71,
        "year": 6
    },
    {
        "payment": 4855.92,
        "fees": 0,
        "payment_w_fees": 4855.92,
        "cost_per_kwh": 0.29874960674092504,
        "number": 72,
        "year": 6
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 73,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 74,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 75,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 76,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 77,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 78,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 79,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 80,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 81,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 82,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 83,
        "year": 7
    },
    {
        "payment": 4879.96,
        "fees": 0,
        "payment_w_fees": 4879.96,
        "cost_per_kwh": 0.30173710280833427,
        "number": 84,
        "year": 7
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 85,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 86,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 87,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 88,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 89,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 90,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 91,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 92,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 93,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 94,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 95,
        "year": 8
    },
    {
        "payment": 4904.11,
        "fees": 0,
        "payment_w_fees": 4904.11,
        "cost_per_kwh": 0.30475447383641757,
        "number": 96,
        "year": 8
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 97,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 98,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 99,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 100,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 101,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 102,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 103,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 104,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 105,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 106,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 107,
        "year": 9
    },
    {
        "payment": 4928.39,
        "fees": 0,
        "payment_w_fees": 4928.39,
        "cost_per_kwh": 0.3078020185747818,
        "number": 108,
        "year": 9
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 109,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 110,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 111,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 112,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 113,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 114,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 115,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 116,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 117,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 118,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 119,
        "year": 10
    },
    {
        "payment": 4952.78,
        "fees": 0,
        "payment_w_fees": 4952.78,
        "cost_per_kwh": 0.31088003876052955,
        "number": 120,
        "year": 10
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 121,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 122,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 123,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 124,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 125,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 126,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 127,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 128,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 129,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 130,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 131,
        "year": 11
    },
    {
        "payment": 4977.3,
        "fees": 0,
        "payment_w_fees": 4977.3,
        "cost_per_kwh": 0.3139888391481349,
        "number": 132,
        "year": 11
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 133,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 134,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 135,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 136,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 137,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 138,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 139,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 140,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 141,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 142,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 143,
        "year": 12
    },
    {
        "payment": 5001.94,
        "fees": 0,
        "payment_w_fees": 5001.94,
        "cost_per_kwh": 0.31712872753961624,
        "number": 144,
        "year": 12
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 145,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 146,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 147,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 148,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 149,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 150,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 151,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 152,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 153,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 154,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 155,
        "year": 13
    },
    {
        "payment": 5026.7,
        "fees": 0,
        "payment_w_fees": 5026.7,
        "cost_per_kwh": 0.32030001481501236,
        "number": 156,
        "year": 13
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 157,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 158,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 159,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 160,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 161,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 162,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 163,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 164,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 165,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 166,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 167,
        "year": 14
    },
    {
        "payment": 5051.58,
        "fees": 0,
        "payment_w_fees": 5051.58,
        "cost_per_kwh": 0.3235030149631626,
        "number": 168,
        "year": 14
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 169,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 170,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 171,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 172,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 173,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 174,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 175,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 176,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 177,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 178,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 179,
        "year": 15
    },
    {
        "payment": 5076.58,
        "fees": 0,
        "payment_w_fees": 5076.58,
        "cost_per_kwh": 0.3267380451127942,
        "number": 180,
        "year": 15
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 181,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 182,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 183,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 184,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 185,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 186,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 187,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 188,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 189,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 190,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 191,
        "year": 16
    },
    {
        "payment": 5101.71,
        "fees": 0,
        "payment_w_fees": 5101.71,
        "cost_per_kwh": 0.3300054255639221,
        "number": 192,
        "year": 16
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 193,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 194,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 195,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 196,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 197,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 198,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 199,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 200,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 201,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 202,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 203,
        "year": 17
    },
    {
        "payment": 5126.97,
        "fees": 0,
        "payment_w_fees": 5126.97,
        "cost_per_kwh": 0.3333054798195614,
        "number": 204,
        "year": 17
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 205,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 206,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 207,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 208,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 209,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 210,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 211,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 212,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 213,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 214,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 215,
        "year": 18
    },
    {
        "payment": 5152.35,
        "fees": 0,
        "payment_w_fees": 5152.35,
        "cost_per_kwh": 0.33663853461775695,
        "number": 216,
        "year": 18
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 217,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 218,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 219,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 220,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 221,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 222,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 223,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 224,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 225,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 226,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 227,
        "year": 19
    },
    {
        "payment": 5177.85,
        "fees": 0,
        "payment_w_fees": 5177.85,
        "cost_per_kwh": 0.3400049199639345,
        "number": 228,
        "year": 19
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 229,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 230,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 231,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 232,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 233,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 234,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 235,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 236,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 237,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 238,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 239,
        "year": 20
    },
    {
        "payment": 5203.48,
        "fees": 0,
        "payment_w_fees": 5203.48,
        "cost_per_kwh": 0.3434049691635738,
        "number": 240,
        "year": 20
    }
].reduce((r,d) => {
    if (!r.map(j => j.year).includes(d.year)) {
         r.push({...d}) //, cost_per_kwh: Math.round(r.cost_per_kwh * 100) / 100})
    }
    return r;
}, [])